






























import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import ApiProvider from '@/common/apis/ApiProvider';
import { ResetDeviceRequest } from '../../common/apis/DeviceApi';
@Component({})
export default class ResetDeviceButton extends Vue {

    @Prop()
    public deviceNumber: string;

    public deleteConfirm: string = '';

    public isDeleting: boolean = false;

    public get test() {
        return this.$t('device.reset.modal.input-for-confirmation');
    }

    public get validationText(): string {
        return this.$t('device.reset.modal.input-for-confirmation').toString();
    }

    public get validation() {
        return this.deleteConfirm.toLowerCase() === this.validationText.toLowerCase();
    }

    public async resetClick() {
        if (this.validation) {
            this.isDeleting = true;
            const api = ApiProvider.getDeviceApi();
            try {
                await api.resetDevice(new ResetDeviceRequest({ deviceId: this.deviceNumber}));
                this.$store.commit('devices/setResettedDevice', this.deviceNumber);
                await this.$store.dispatch('clear');
                this.$router.replace('/devices');
            } finally {
                this.isDeleting = false;
            }
        }
    }
}
